module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Camera-917aba52424f547f6a83a11690e8b7af.svg";